export enum LocalStorageProperties {
  AUTH_TOKEN = 'AUTH_TOKEN',
  ID_TOKEN = 'ID_TOKEN',
  TOKEN_TYPE = 'TOKEN_TYPE',
  ACCOUNT_INFO = 'ACCOUNT_INFO',
  SELECTED_MANDANT = 'SELECTED_MANDANT',
}
